import { render, staticRenderFns } from "./IconHubsWarning.vue?vue&type=template&id=56a75fc8&"
import script from "./IconHubsWarning.vue?vue&type=script&lang=js&"
export * from "./IconHubsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a75fc8')) {
      api.createRecord('56a75fc8', component.options)
    } else {
      api.reload('56a75fc8', component.options)
    }
    module.hot.accept("./IconHubsWarning.vue?vue&type=template&id=56a75fc8&", function () {
      api.rerender('56a75fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconHubsWarning.vue"
export default component.exports